// Clear cart on page load
window.addEventListener('load', function() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    }
  }).catch(function(error) {
    console.log('Cart clear failed:', error);
  });
});